/**
 * Field-level KYC reject must use the same kyc_rejection email as full reject.
 * Selfie submit requires an explicit face+ID confirmation.
 */

export const SELFIE_ID_CONFIRM_LABEL =
  'I confirm this photo shows my face and my ID document in the same picture.'

export const SELFIE_ID_CONFIRM_REQUIRED =
  'Confirm that your selfie shows both your face and your ID document.'

export function buildFieldRejectEmailReason(fieldDisplayName, rejectionReason) {
  const field = String(fieldDisplayName || 'KYC field').trim()
  const reason = String(rejectionReason || '').trim()
  if (!reason) return field + ' was rejected. Please correct and resubmit.'
  return field + ': ' + reason
}

export function isSelfieIdConfirmed(value) {
  return value === true
}

/**
 * Resolve who to email for a field reject without depending on a stale
 * selectedSubmission / submissions closure.
 */
export function resolveFieldRejectNotifyTarget({
  submissionId,
  userId,
  selectedSubmission,
  submissions,
} = {}) {
  const id = String(submissionId || '')
  const direct = Number(userId)
  if (Number.isFinite(direct) && direct > 0) {
    return { userId: direct }
  }

  const selected =
    selectedSubmission && String(selectedSubmission.id) === id
      ? selectedSubmission
      : null
  const listed = Array.isArray(submissions)
    ? submissions.find((row) => row && String(row.id) === id)
    : null
  const row = selected || listed
  const fromRow = Number(row?.user_id)
  if (Number.isFinite(fromRow) && fromRow > 0) {
    return { userId: fromRow }
  }
  return null
}
